(function () {
  'use strict';

  if (window.stampNewEvent) return;

  // For Web self-serve events: one logical action gets one lowercase UUID v4 on common.event_id.
  // Callers get a cloned record; business fields and the caller's common object are left alone.
  // Send, queue flush, and destination arrival confirmation must not call this.

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID().toLowerCase();
    }
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.prototype.map.call(bytes, function (byte) {
        return ('0' + byte.toString(16)).slice(-2);
      }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) +
        '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }
    throw new Error('tracking_event_id step=uuid_unavailable');
  }

  function stampNewEvent(record) {
    if (!record || !record.common || typeof record.common !== 'object') return record;
    const stamped = Object.assign({}, record);
    stamped.common = Object.assign({}, record.common);
    stamped.common.event_id = createEventId();
    return stamped;
  }

  window.stampNewEvent = stampNewEvent;
})();
